const AUTH_TOKEN_STORAGE_KEY = 'ulp.auth.token';
const CURRENT_USER_STORAGE_KEY = 'ulp.auth.current-user';

const canUseStorage = () => typeof window !== 'undefined';

export const getAuthToken = () => {
  if (!canUseStorage()) {
    return undefined;
  }

  return window.localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) ?? undefined;
};

export const setAuthToken = (token?: string) => {
  if (!canUseStorage()) {
    return;
  }

  if (!token) {
    window.localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    return;
  }

  window.localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
};

export const clearAuthToken = () => {
  setAuthToken();
};

export const getCurrentUser = (): API.AppCurrentUser | undefined => {
  if (!canUseStorage()) {
    return undefined;
  }

  const value = window.localStorage.getItem(CURRENT_USER_STORAGE_KEY);
  if (!value) {
    return undefined;
  }

  try {
    return JSON.parse(value) as API.AppCurrentUser;
  } catch {
    window.localStorage.removeItem(CURRENT_USER_STORAGE_KEY);
    return undefined;
  }
};

export const setCurrentUser = (currentUser?: API.AppCurrentUser) => {
  if (!canUseStorage()) {
    return;
  }

  if (!currentUser) {
    window.localStorage.removeItem(CURRENT_USER_STORAGE_KEY);
    return;
  }

  window.localStorage.setItem(
    CURRENT_USER_STORAGE_KEY,
    JSON.stringify(currentUser),
  );
};

export const clearCurrentUser = () => {
  setCurrentUser();
};

export const clearSession = () => {
  clearAuthToken();
  clearCurrentUser();
};
